import { counter } from '../../util/csm/csm';
import { Logger } from '../../util/logger/logger';

export interface ClientsideMetrics {
    beforeMarkup: Date,
    afterMarkup: Date,
    afterProps: Date,
    beforeHydration: Date,
    afterHydration: Date;
}

declare let window: Window & {
    DVWebNode?: {
        perfMetrics: {
            [widgetName: string]: Partial<ClientsideMetrics>[];
        };
    };
};

// This could happen before the widget is in the DOM
export const markBeforeHydration = (widgetName: string, index: number) => {
    const now = new Date();
    if (!window.DVWebNode) {
        window.DVWebNode = { perfMetrics: {} };
    };
    const { perfMetrics } = window.DVWebNode;
    if (!perfMetrics[widgetName]) {
        perfMetrics[widgetName] = [];
    }
    if (!perfMetrics[widgetName][index]) {
        perfMetrics[widgetName][index] = {};
    }
    perfMetrics[widgetName][index].beforeHydration = now;
};

// Assumes that this is called after markBeforeHydration
export const markAfterHydration = (widgetName: string, index: number) => {
    const now = new Date();
    window.DVWebNode!.perfMetrics[widgetName][index].afterHydration = now;
};

export const platformCounter = (metric: string, widgetName: string, index: number, value: number) => {
    counter(`DVWebNode:${widgetName}:${index}:${metric}`, value, false);
};

// Assumed that this is called after all markers are present
export const emitCounters = (widgetName: string, index: number, logger: Logger) => {
    if (!window.DVWebNode) {
        return logger.error(`Cannot emit counters for ${widgetName}:${index} as perfMetrics have not been collected`);
    }
    const { perfMetrics } = window.DVWebNode;
    if (!perfMetrics || !perfMetrics[widgetName] || !perfMetrics[widgetName][index]) {
        return logger.error(`Cannot emit counters for ${widgetName}:${index} as it has no entry in perfMetrics`);
    }
    const metrics = perfMetrics[widgetName][index];
    const { beforeMarkup, afterMarkup, beforeHydration, afterHydration } = metrics;
    platformCounter('HydrationExecute', widgetName, index, afterHydration!.getTime() - beforeHydration!.getTime());
    platformCounter('Noninteractive', widgetName, index, afterHydration!.getTime() - afterMarkup!.getTime());
    platformCounter('WidgetLoaded', widgetName, index, afterHydration!.getTime() - beforeMarkup!.getTime());
};